/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/324-circle-down': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 8A8 8 0 100 8a8 8 0 0016 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z"/><path pid="1" d="M4.957 5.543L3.543 6.957 8 11.414l4.457-4.457-1.414-1.414L8 8.586z"/>'
  }
})
